/* TR1 Moms LP: swipe carousels with dots + arrows; optional autoplay (off by default; pauses on touch/hover, respects reduced motion) */
(function(){
  function init(car){
    if(car.dataset.ready) return; car.dataset.ready='1';
    var trk=car.querySelector('.trk'), slides=[].slice.call(car.querySelectorAll('.sl')), dots=car.querySelector('.dots');
    if(!trk||slides.length<2) return;
    var i=0, paused=false, ms=parseInt(car.dataset.autoplay||'0',10);
    slides.forEach(function(_,n){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Slide '+(n+1));b.onclick=function(){go(n)};dots.appendChild(b)});
    var bs=dots.querySelectorAll('button');
    function mark(n){i=n;bs.forEach(function(b,k){b.classList.toggle('on',k===n)});if(car.querySelector('.arw.l'))car.querySelector('.arw.l').style.opacity=n===0?.45:1}
    function go(n){trk.scrollTo({left:n*trk.clientWidth,behavior:'smooth'});mark(n)}
    trk.addEventListener('scroll',function(){var n=Math.round(trk.scrollLeft/trk.clientWidth);if(n!==i)mark(n)},{passive:true});
    ['touchstart','mouseenter','focusin'].forEach(function(e){car.addEventListener(e,function(){paused=true},{passive:true})});
    car.addEventListener('mouseleave',function(){paused=false});
    var pv=car.querySelector('.arw.l'), nx=car.querySelector('.arw.r');
    if(pv) pv.onclick=function(){paused=true;go((i-1+slides.length)%slides.length)};
    if(nx) nx.onclick=function(){paused=true;go((i+1)%slides.length)};
    mark(0);
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!ms) return;
    var io=('IntersectionObserver' in window)?new IntersectionObserver(function(en){car._vis=en[0].isIntersecting}):null; if(io) io.observe(car); else car._vis=true;
    setInterval(function(){if(!paused&&car._vis) go((i+1)%slides.length)},ms);
  }
  function all(){document.querySelectorAll('.tr1-moms [data-car]').forEach(init)}
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
